import { render, staticRenderFns } from "./SlideSettings.vue?vue&type=template&id=19f44ed3&scoped=true"
import script from "./SlideSettings.vue?vue&type=script&lang=js"
export * from "./SlideSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f44ed3",
  null
  
)

export default component.exports